import styled from "styled-components";

export const StyledReviewsPageWrapper = styled.div`
  margin-top: 1.5rem;
`;
